import React from 'react';
import { Box, FormControl, TextField, FormHelperText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ReactComponent as MagnifyingGlass } from '../../../../../image/magnifying-glass.svg';

const useStyles = makeStyles((theme) => {
    return {
        inputStyle: {
            '&.MuiOutlinedInput-root > .MuiOutlinedInput-notchedOutline': {
                borderRadius: '4px',
                borderWidth: '1px',
                borderColor: theme.palette.grey.border,
            },
            '&.Mui-focused > .MuiOutlinedInput-notchedOutline': {
                borderWidth: '2px',
                borderColor: theme.palette.primary.main,
            },
        },
        formWidth: {
            width: 420,
            [theme.breakpoints.down('md')]: {
                width: 260,
            },
        },
    };
});

const SearchField = ({ disabled, handleSearchChange, savedSearch, searchText, sx, ...restOfProps }) => {
    const [searchValue, setSearchValue] = React.useState(savedSearch ? savedSearch : '');

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) handleSearchChange(searchValue, 'search');
    };

    const classes = useStyles();

    return (
        <FormControl
            className={classes.formWidth}
            sx={sx}
        >
            <TextField
                id="search-field"
                size="small"
                label="Search"
                disabled={disabled}
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
                onKeyDown={handleKeyDown}
                inputProps={{
                    autoComplete: 'nope',
                }}
                InputProps={{
                    startAdornment: (
                        <MagnifyGlassAdornment
                            onClick={() => handleSearchChange(searchValue, 'search')}
                            disabled={disabled}
                        />
                    ),
                    className: classes.inputStyle,
                }}
            />
            <FormHelperText sx={{ color: (theme) => theme.palette.primary.main }}>{searchText}</FormHelperText>
        </FormControl>
    );
};

const MagnifyGlassAdornment = (props) => {
    return (
        <Box
            {...props}
            component={MagnifyingGlass}
            sx={{
                cursor: 'pointer',
                height: 15,
                paddingRight: (theme) => theme.spacing(1),
                fill: (theme) => theme.palette.primary.main,
            }}
        />
    );
};

export default SearchField;
